module.exports = __webpack_public_path__ + "static/media/image4.b467e676.jpg";